import { useState, useEffect } from "react";
import SidePanel from "../../components/SidePanel";
import { Link } from "react-router-dom";
import Upload_Picture from "../../assets/icons/Upload_Picture.svg";
import remove_recipient from "../../assets/icons/remove_recipient.svg";
import { useParams } from "react-router-dom";
import Spinner from "../../components/Spinner";
import { toast } from "react-toastify";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { ReactComponent as ReloadIcon } from "../../assets/icons/reload.svg";
import ConfirmationModal from "../../components/ConfirmationModal";
import { traits } from "../../utils/constant";
import { FaEdit } from "react-icons/fa";
import moment from "moment";
const dateKeys = {
  Graduation: "graduationDate",
  "House Warming": "housewarmingDate",
  "Baby Shower": "babyshowerDate",
  "Occasion Anniversary": "occasionanniversaryDate",
};
const EditRecipient = () => {
  const { id } = useParams();
  const animatedComponents = makeAnimated();

  const [removeModal, setRemoveModal] = useState(false);
  const [loader, setLoader] = useState(true);
  const [saveLoader, setSaveLoader] = useState(false);
  const [occasion, setOccasion] = useState([]);
  const [selectedOccasions, setSelectedOccasions] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const [selectedImage, setSelectedFile] = useState(null);
  const [filteredOcassions, setFilteredOcassions] = useState([]);
  const [states, setStates] = useState([]);
  const [data, setData] = useState({
    fullName: "",
    gender: "",
    dob: "",
    anniversaryDate: "",
    // babyshowerDate: "",
    // graduationDate: "",
    // housewarmingDate: "",
    // occasionanniversaryDate: "",
    email: "",
    relationShip: "",
    streetAddress: "",
    city: "",
    zipCode: "",
    state: "",
    profile_image: "",
    characterTraits: [],
    eventsId: [],
  });

  function formatDateStringToISO(dateString) {
    // Parse the date string into a Date object
    const date = new Date(dateString + "T00:00:00.000Z"); // Append time and Z for UTC

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      throw new Error("Invalid date string");
    }

    // Get the ISO string
    const isoString = date.toISOString(); // This will give you 'YYYY-MM-DDTHH:mm:ss.sssZ'

    // Replace the 'Z' with '+00:00' to match your desired format
    return isoString.replace("Z", "+00:00");
  }
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);

    // Use UTC methods to avoid timezone shifting
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const fetchOccasion = async () => {
      const token = localStorage?.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/event/get-active-event`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": token,
          },
        }
      );
      const res = await response.json();
      const status = res.code;
      if (status === 200) {
        setOccasion(res.data);
      }
    };
    fetchOccasion();
  }, []);

  const handleOccasionChange = (selectedOptions) => {
    setSelectedOccasions(selectedOptions);
  };

  const handleSave = async () => {
    const token = localStorage?.getItem("token");
    setSaveLoader(true);

    if (selectedImage) {
      const formData = new FormData();
      formData.append("image", selectedImage);

      try {
        const uploadResponse = await fetch(
          `${process.env.REACT_APP_API_URL}/api/auth/upload-s3`,
          {
            method: "POST",
            body: formData,
          }
        );

        const uploadData = await uploadResponse.json();

        if (uploadResponse.ok && uploadData.data.detail) {
          data.profile_image = uploadData.data.detail;
        } else {
          throw new Error("Failed to upload image");
        }
      } catch (error) {
        console.error("Upload error:", error);
        toast.error("Failed to upload image");
        setSaveLoader(false);
        return;
      }
    }

    occasion.forEach((occasion) => {
      const fieldName = normalizeEventName(occasion?.name);
      if (
        !filteredOcassions.some((filtered) => filtered.name === occasion.name)
      ) {
        delete data[fieldName]; // Delete the dynamically generated field
      }
    });
    for (const item of filteredOcassions) {
      const fieldName = normalizeEventName(item.name); // Dynamically create the field name
      console.log("Checking field:", fieldName, "with value:", data[fieldName]); // Log field values

      // If the event has a date and the corresponding field in data is empty
      if (item.date && !data[fieldName]) {
        toast.error(`Please fill the date for ${item.name}`);
        setSaveLoader(false);
        return; // Exit the function immediately on first error
      }
      if (data[fieldName]) {
        const userDate = new Date(data[fieldName]); // Assume data[fieldName] is a valid date string
        const utcDate = userDate.toISOString(); // Converts to UTC in ISO format
        console.log(`Converted UTC date for ${item.name}:`, utcDate);

        // You can save the utcDate back to data or use it as needed
        data[fieldName] = utcDate; // Optionally update the data object
      }
    }
    const eventId = selectedOccasions.map((occasion) => occasion.value);
    data.eventsId = eventId;

    delete data.email;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/recipient/edit-recipient/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": token,
          },
          body: JSON.stringify(data),
        }
      );
      const result = await response.json();

      if (result.code === 200) {
        toast.success("Recipient updated successfully.");
        setTimeout(() => {
          window.location.href = "/dashboard/address_book";
        }, 2000);
      } else {
        throw new Error(
          result.message || "Failed to update recipient's profile."
        );
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.error(error.message || "An error occurred during the update.");
    } finally {
      setSaveLoader(false);
    }
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImagePreview(URL.createObjectURL(file));
      setSelectedFile(file);
    }
  };

  useEffect(() => {
    if (data.profile_image) {
      setImagePreview(data.profile_image);
    }
  }, [data.profile_image]);

  useEffect(() => {
    return () => {
      if (imagePreview && !data.profile_image) {
        URL.revokeObjectURL(imagePreview);
      }
    };
  }, [imagePreview, data.profile_image]);

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    let newValue = value;

    if (type === "date") {
      // Convert to ISO UTC midnight
      newValue = value ? new Date(value + "T00:00:00.000Z").toISOString() : "";
    }

    setData((prev) => ({ ...prev, [name]: newValue }));
  };

  const isGenderSelected = (gender) => data.gender === gender;

  const handleTraitSelection = (trait) => {
    const traitsArray = Array.isArray(data.characterTraits)
      ? data.characterTraits
      : [];
    const newTraits = traitsArray.includes(trait)
      ? traitsArray.filter((t) => t !== trait)
      : [...traitsArray, trait];
    setData({
      ...data,
      characterTraits: newTraits,
    });
  };

  const isTraitSelected = (trait) => {
    return (
      Array.isArray(data.characterTraits) &&
      data.characterTraits.includes(trait)
    );
  };

  const handleGenderSelection = (gender) => {
    setData({ ...data, gender });
  };

  const toggleRemoveModal = () => {
    setRemoveModal(!removeModal);
  };

  useEffect(() => {
    const fetchRecipients = async (customerID, token) => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/customer/get-customer-recipients/${customerID}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": token,
          },
        }
      );
      const data = await res.json();
      data.data = data.data.filter((recipient) => recipient._id === id);
      const fetchedData = data.data[0];
      const updatedData = {};

      // Check each field in fetchedData and only add it if it's part of the filtered occasions
      if (fetchedData) {
        // Iterate over the filtered occasions and match the fields dynamically
        occasion.forEach((occasion) => {
          const fieldName = normalizeEventName(occasion.name); // Dynamically create field name

          if (fetchedData[fieldName]) {
            updatedData[fieldName] = fetchedData[fieldName]; // Only add the field if it exists in fetchedData
            console.log(
              "dataaaaa",
              updatedData[fieldName],
              fetchedData[fieldName]
            );
          }
        });

        // You can also include other static fields if they exist in the fetched data
        updatedData.fullName = fetchedData.fullName;
        updatedData.gender = fetchedData.gender;
        updatedData.dob = fetchedData.dob;
        updatedData.email = fetchedData.email;
        updatedData.anniversaryDate = fetchedData.anniversaryDate; // Example of static field
        updatedData.relationShip = fetchedData.relationShip;
        updatedData.characterTraits = fetchedData.characterTraits;
        updatedData.profile_image = fetchedData.profile_image;
        updatedData.streetAddress = fetchedData.streetAddress;
        updatedData.city = fetchedData.city;
        updatedData.zipCode = fetchedData.zipCode;
        updatedData.state = fetchedData.stateId?._id;
        // " " +
        // fetchedData.city +
        // " " +
        // fetchedData.stateId?.state;
        updatedData.eventsId = fetchedData.eventsId;
      }

      // After updating the dynamic fields, set the data state
      setData(updatedData);
      // setData({
      //   fullName: fetchedData.fullName,
      //   gender: fetchedData.gender,
      //   dob: fetchedData.dob,
      //   email: fetchedData.email,
      //   anniversaryDate: fetchedData.anniversaryDate,
      //   // babyshowerDate: fetchedData.babyshowerDate,
      //   // graduationDate: fetchedData.graduationDate,
      //   // housewarmingDate: fetchedData.housewarmingDate,
      //   // occasionanniversaryDate: fetchedData.occasionanniversaryDate,
      //   relationShip: fetchedData.relationShip,
      //   characterTraits: fetchedData.characterTraits,
      //   profile_image: fetchedData.profile_image,
      //   address:
      //     fetchedData.streetAddress +
      //     " " +
      //     fetchedData.city +
      //     " " +
      //     fetchedData.stateId?.state,
      //   eventsId: fetchedData.eventsId,
      // });
      setSelectedOccasions(
        fetchedData?.eventsId?.map((occasion) => ({
          value: occasion._id,
          label: occasion.name,
        }))
      );
      setLoader(false);
    };
    const customerID = localStorage?.getItem("ID");
    const token = localStorage?.getItem("token");
    if (customerID && token) {
      fetchRecipients(customerID, token);
    }
  }, [id, occasion]);

  useEffect(() => {
    if (occasion.length > 0) {
      const temp = occasion.filter(
        (item) =>
          selectedOccasions.some((it) => it.value === item._id) &&
          item.category === "not-fixed"
      );
      setFilteredOcassions(temp);
    }
  }, [selectedOccasions, occasion]);
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/state/active_state_listing`
        );
        const res = await response.json();
        if (res.code === 200) {
          setStates(res.data);
        }
      } catch (error) {}
    };
    fetchStates();
  }, []);
  const normalizeEventName = (eventName) => {
    return (
      eventName
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "") // Remove non-alphanumeric characters (e.g., apostrophes, spaces)
        .replace(/\s+/g, "") // Remove spaces
        .replace(/^([a-z])/g, (match) => match.toLowerCase()) + "Date"
    ); // Ensure camelCase and add 'Date'
  };
  console.log({ data });
  useEffect(() => {
    if (filteredOcassions.length > 0) {
      setData((prevData) => {
        const newFields = filteredOcassions.reduce((acc, { name }) => {
          const fieldName = normalizeEventName(name);
          if (!prevData[fieldName]) acc[fieldName] = "";
          return acc;
        }, {});

        if (Object.keys(newFields).length === 0) return prevData;
        return { ...prevData, ...newFields };
      });
    }
  }, [filteredOcassions]);
  if (loader) {
    return (
      <section className="flex ">
        <SidePanel />
        <div className="w-full xl:pl-[20%] lg:pl-10 md:pl-6 sm:pl-4 pl-2 pt-[6rem] px-4">
          <div className="m-10 w-full h-screen flex items-center justify-center">
            <Spinner props={"Loading"} size={100} />
          </div>
        </div>
      </section>
    );
  }

  const dateInputs = filteredOcassions.map((item) => {
    const fieldName = normalizeEventName(item.name);

    return (
      <div key={item._id} className="flex flex-col w-full text-lg">
        <label className="text-sm text-gray-400">{item.name}</label>
        <input
          type="date"
          name={fieldName} // Use the normalized field name
          value={
            data[fieldName]
              ? moment.utc(data[fieldName]).format("YYYY-MM-DD") // force UTC
              : ""
          }
          onChange={handleChange}
          className="bg-[#F1F1F1] border-b-2 py-2 border-gray-300 placeholder:text-gray-300 w-full"
        />
      </div>
    );
  });

  return (
    // <section className="flex max-w-[1200px] mx-auto">
    <section className="flex mx-auto px-4 sm:px-2">
      <SidePanel />
      <div className="w-full xl:pl-[20%] lg:pl-10 md:pl-6 sm:pl-4 pl-2 pt-[6rem] px-4">
        <h3 className="mb-5">
          <Link to="/dashboard/address_book" className="hover:underline">
            Address Book
          </Link>
          {">"} <span className="text-primary">Recipient Details</span>
        </h3>
        <div className="bg-[#F1F1F1] p-5 rounded-md my-5">
          <div className="flex md:flex-row flex-col items-start">
            <div className="flex flex-col items-center space-y-3">
              {imagePreview ? (
                <>
                  <img
                    src={imagePreview}
                    alt="Profile Preview"
                    className="w-52 h-52 rounded-lg"
                  />
                  <button
                    onClick={() => document.getElementById("fileInput").click()}
                    className="bg-primary text-white rounded-lg p-2 hover:bg-primary-dark duration-200 ease-linear flex"
                    title="Change Image"
                  >
                    <FaEdit size={18} />
                  </button>
                </>
              ) : (
                <div
                  className="md:mx-0 mx-auto group w-52 h-52 rounded-lg bg-[#D2D5D7] hover:border-2 hover:border-dashed hover:border-black cursor-pointer duration-200 ease-linear flex items-center justify-center"
                  onClick={() => document.getElementById("fileInput").click()}
                  title="Upload Image"
                >
                  <img
                    src={Upload_Picture}
                    alt="Upload Picture"
                    width={40}
                    className="opacity-50 group-hover:opacity-100 duration-200 ease-linear"
                  />
                </div>
              )}

              <input
                type="file"
                id="fileInput"
                onChange={handleImageChange}
                accept="image/*"
                className="hidden"
              />
            </div>

            <div className="flex flex-col w-full md:p-3 py-3">
              <div className="flex md:items-start justify-between w-full md:mb-5 mt-5 max-sm:flex-wrap">
                <div className="md:w-[80%] w-full">
                  <div className="flex flex-col w-full text-2xl">
                    <label className="text-sm text-gray-400">Name</label>
                    <input
                      type="text"
                      name="fullName"
                      value={data.fullName || ""}
                      onChange={handleChange}
                      className="bg-[#F1F1F1] border-b-2 py-2 border-gray-300 placeholder:text-gray-300 w-full"
                    />
                  </div>
                  <div className="flex items-center w-full gap-x-4">
                    <div className="flex flex-col w-full">
                      <label className="my-2 text-lg text-gray-400">
                        Relationship
                      </label>
                      <select
                        className="bg-[#ffffff] border-b-2 border-gray-300 py-3 w-full"
                        name="relationShip"
                        value={data.relationShip}
                        onChange={handleChange}
                      >
                        <option value="">--Select--</option>
                        <option value="Both Parents">Both Parents</option>
                        <option value="Father">Father</option>
                        <option value="Mother">Mother</option>
                        <option value="Uncle">Uncle</option>
                        <option value="Aunt">Aunt</option>
                        <option value="Husband">Husband</option>
                        <option value="Wife">Wife</option>
                        <option value="A Couple">A Couple</option>
                        <option value="Son">Son</option>
                        <option value="Daughter">Daughter</option>
                        <option value="Sister">Sister</option>
                        <option value="Brother">Brother</option>
                        <option value="GF">GF</option>
                        <option value="BF">BF</option>
                        <option value="Grandad">Grandad</option>
                        <option value="Grandmom">Grandmom</option>
                        <option value="Grandson">Grandson</option>
                        <option value="Grandaughter">Grandaughter</option>
                      </select>
                    </div>
                    <div className="flex flex-col w-full mt-4">
                      <label className="text-lg text-gray-400">Occasion</label>
                      <Select
                        styles={{
                          control: (baseStyles, { isFocused }) => ({
                            ...baseStyles,
                            padding: "5px",
                            borderRadius: "5px",
                            border: "2px solid #bbb",
                            background: "none",
                            width: "100%",
                          }),
                          multiValue: (styles) => ({
                            ...styles,
                            backgroundColor: "#F66061",
                            borderRadius: "10px",
                          }),
                          multiValueLabel: (styles) => ({
                            ...styles,
                            color: "white",
                          }),
                          multiValueRemove: (styles) => ({
                            ...styles,
                            color: "white",
                            ":hover": {
                              backgroundColor: "#F66061",
                              color: "white",
                            },
                            borderRadius: "10px",
                          }),
                          option: (styles, { isFocused, isSelected }) => ({
                            ...styles,
                            backgroundColor: isFocused
                              ? "#F66061"
                              : isSelected
                              ? "#F66061"
                              : null,
                            color:
                              isFocused || isSelected ? "white" : "#F66061",
                            ":active": {
                              ...styles[":active"],
                              backgroundColor: isSelected ? "#F66061" : null,
                            },
                          }),
                        }}
                        className="w-full"
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        isMulti
                        required
                        options={occasion?.map((oc) => ({
                          value: oc._id,
                          label: oc.name,
                        }))}
                        onChange={handleOccasionChange}
                        value={selectedOccasions}
                      />
                    </div>
                  </div>
                </div>
                <div className="flex md:flex-row flex-col md:items-center gap-3 w-fit">
                  {saveLoader ? (
                    <Spinner props=" " size={"80"} />
                  ) : (
                    <button
                      onClick={handleSave}
                      className="border-2 border-primary bg-primary text-white hover:bg-primary-dark py-2 px-10 w-full rounded-sm flex items-center justify-center gap-x-3"
                    >
                      Save
                    </button>
                  )}
                </div>
              </div>
              <div className="flex items-center my-5 gap-x-5 sm:w-[60%]">
                <button
                  className={`xl:px-10 w-full rounded-md py-2 flex items-center justify-center text-xl border-2 ${
                    isGenderSelected("male")
                      ? "bg-primary-light border-primary"
                      : "border-gray-500"
                  }`}
                  onClick={() => handleGenderSelection("male")}
                >
                  Male 🧔🏻‍
                </button>
                <button
                  className={`xl:px-10 w-full rounded-md py-2 flex items-center justify-center text-xl border-2 ${
                    isGenderSelected("female")
                      ? "bg-primary-light border-primary"
                      : "border-gray-500"
                  }`}
                  onClick={() => handleGenderSelection("female")}
                >
                  Female 👩🏻
                </button>
              </div>
            </div>
          </div>
          <div className="border-b-[1.5px] border-black my-5" />
          <div className="md:text-xl font-semibold flex items-center gap-x-5">
            <div className="flex flex-col w-full text-lg">
              <label className="text-sm text-gray-400">Birthday</label>
              <input
                type="date"
                name="dob"
                value={formatDate(data.dob)}
                onChange={handleChange}
                className="bg-[#F1F1F1] border-b-2 py-2 border-gray-300 placeholder:text-gray-300 w-full"
              />
            </div>
            <div className="flex flex-col w-full text-lg">
              <label className="text-sm text-gray-400">Email</label>
              <input
                type="email"
                name="email"
                disabled
                value={data.email || ""}
                onChange={handleChange}
                className="bg-[#F1F1F1] border-b-2 py-2 border-gray-300 placeholder:text-gray-300 w-full"
              />
            </div>
          </div>
          <div className="md:text-xl font-semibold flex items-center mt-6 gap-x-5">
            <div className="grid grid-cols-3 gap-4 w-full">{dateInputs}</div>
          </div>
        </div>
        <div className="bg-[#F1F1F1] p-5 rounded-md my-5">
          <h3 className="text-2xl font-semibold">Character Traits</h3>
          <div className="border-b-[1.5px] border-black my-5" />
          <div className="grid lg:grid-cols-4 grid-cols-3 gap-2 place-items-center my-3">
            {traits.map((trait) => (
              <TraitButton
                key={trait}
                trait={trait}
                isSelected={isTraitSelected(trait)}
                onSelect={() => handleTraitSelection(trait)}
              />
            ))}
          </div>
        </div>

        {/* ********* */}
        <h1 className="text-2xl text-secondary font-semibold">
          Location Detail
        </h1>
        <div className="flex flex-col my-3 w-full">
          <div className="flex flex-col w-full my-2">
            <label className="text-lg text-gray-400">Street Address</label>
            <input
              type="text"
              name="streetAddress"
              value={data.streetAddress}
              required
              onChange={handleChange}
              className="py-3 bg-none border-b-2 focus:outline-none border-gray-300 placeholder:text-gray-300 w-full"
            />
          </div>
          <div className="flex flex-col w-full my-2">
            <label className="text-lg text-gray-400">City</label>
            <input
              type="text"
              name="city"
              value={data.city}
              required
              onChange={handleChange}
              className="py-3 bg-none border-b-2 focus:outline-none border-gray-300 placeholder:text-gray-300 w-full"
            />
          </div>
          <div className="flex flex-col w-full my-2">
            <label className="text-lg text-gray-400">Zip Code</label>
            <input
              type="number"
              name="zipCode"
              value={data.zipCode}
              required
              maxLength={5}
              max={5}
              onChange={(e) => {
                // Ensure the input doesn't exceed 5 digits
                if (e.target.value.length <= 5) {
                  handleChange(e);
                }
              }}
              className="py-3 bg-none border-b-2 focus:outline-none border-gray-300 placeholder:text-gray-300 w-full"
            />
          </div>
          <div className="flex flex-col w-full my-2">
            <label className="text-lg text-gray-400">State</label>
            <select
              name="state"
              value={data.state}
              onChange={handleChange}
              required
              className="py-3 bg-white border-b-2 border-gray-300 focus:outline-none placeholder:text-gray-300 w-full"
            >
              <option value="">Choose State</option>
              {states
                .slice() // Create a copy to avoid mutating the original array
                .sort((a, b) => a.state.localeCompare(b.state)) // Sort alphabetically
                .map((state) => (
                  <option key={state._id} value={state._id}>
                    {state.state}
                  </option>
                ))}
            </select>
          </div>
        </div>
      </div>
      {removeModal && (
        <ConfirmationModal
          title="Remove Recipient"
          message="Are you sure you want to remove this Recipient from Address Book?"
          imageSrc={remove_recipient}
          onConfirm={() => {
            return;
          }}
          onCancel={toggleRemoveModal}
          confirmText="Yes"
          cancelText="No"
          toggleModal={toggleRemoveModal}
        />
      )}
    </section>
  );
};

export default EditRecipient;

const TraitButton = ({ trait, isSelected, onSelect }) => (
  <button
    className={`w-full rounded-md py-3 flex items-center justify-center text-xl border-2 ${
      isSelected ? "bg-primary-light border-primary" : "border-gray-500"
    }`}
    onClick={onSelect}
  >
    {trait}
  </button>
);
